import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full bg-secondary-100 border-t border-secondary-200">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-film-fill text-accent-400 text-xl" />
              </span>
              <span className="font-heading text-lg font-extrabold text-foreground-950">
                大师兄<span className="text-accent-600">影视</span>
              </span>
            </div>
            <p className="text-sm text-foreground-700 leading-6 max-w-md">
              大师兄影视是一个影视资源聚合与展示平台，汇聚最新电影、电视剧等丰富内容，
              覆盖多种类型与题材，帮助每一位影迷快速发现并浏览感兴趣的作品。
            </p>
            <p className="mt-4 text-xs text-foreground-600 leading-5">
              本站仅提供影视信息展示与资料查询，不提供任何播放或下载服务，所有内容请前往正规影视平台观看。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950 mb-3">
              <Link to="/category/全部" className="hover:text-primary-600 transition-colors cursor-pointer">
                快速导航
              </Link>
            </h4>
            <ul className="space-y-2 text-sm text-foreground-700">
              <li><Link to="/" className="hover:text-accent-600 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/电影" className="hover:text-accent-600 transition-colors cursor-pointer">电影频道</Link></li>
              <li><Link to="/category/电视剧" className="hover:text-accent-600 transition-colors cursor-pointer">电视剧频道</Link></li>
              <li><Link to="/search?q=悬疑" className="hover:text-accent-600 transition-colors cursor-pointer">悬疑专区</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950 mb-3">
              <Link to="/about" className="hover:text-primary-600 transition-colors cursor-pointer">
                关于与支持
              </Link>
            </h4>
            <ul className="space-y-2 text-sm text-foreground-700">
              <li><Link to="/about" className="hover:text-accent-600 transition-colors cursor-pointer">关于我们</Link></li>
              <li><span className="flex items-center gap-2"><i className="ri-mail-line" /> feedback@dsx-movie.com</span></li>
              <li><span className="flex items-center gap-2"><i className="ri-customer-service-2-line" /> 意见反馈（详见关于页）</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-foreground-600">
          <p>© {year} 大师兄影视 · 影视资源聚合展示平台</p>
          <p className="flex items-center gap-4">
            <span>京ICP备00000000号-1</span>
            <span className="hidden sm:inline">仅供学习交流使用</span>
          </p>
        </div>
      </div>
    </footer>
  );
}